
import React, { Component } from "react";
import Row from "reactstrap/lib/Row";
import Col from "reactstrap/lib/Col";
import { Button } from 'reactstrap';
import ApiEndpoints from "../../../constants/api_endpoints";
import InputFeild from "../../global/form/input"
import "../../../styles/button.css"
import {Icon} from '@material-ui/core';
import store from "../../../store";
import { setError, setSuccess, setLoader } from "../../../actions/action-creators";
import { Input } from 'reactstrap';
import ConfirmAction from "../../global/confirm-action";
import moment from "moment";

class JobUserLevel extends Component {
    constructor(props) {
      super(props);
      this.state = {
           isConfirm : false,
           userLevelData: [],
           isAddUserLevel: false
        }
    }

    async componentDidMount(){
        await this.fetchPartnerLevel() ;
    }
  

    fetchPartnerLevel = async () => {
        let { job } = this.props;
        store.dispatch(setLoader(true))
        let body = { job_id: job.job_id } 
        try {
            let apiData = await ApiEndpoints.JobTaskPayment.selectUserLevel(body);
            this.setState({ userLevelData: apiData.data.data })
        }
        catch(e){
            store.dispatch(setError({show: true, message: e.response ? e.response.data.message : e.toString()}))
        }
        store.dispatch(setLoader(false))
    } 
    
    addUserLevel = async (e) => {
        e.preventDefault();
        let { isAddUserLevel } = this.state;
        let { job } = this.props;
        store.dispatch(setLoader(true))
        try {
            if(!isAddUserLevel.pmw_id.toLowerCase().includes("pmw")) throw new Error("Invalid PMW Id")
            let apiData = await ApiEndpoints.User.fetchUsersByFilter({ limit: 1, search : isAddUserLevel.pmw_id });
            let userList = apiData.data.data.rows;
            if(!userList.length) throw new Error("PMW Id Not Found")

            let body = { 
                job_id: job.job_id,
                user_id: userList[0].user_id,
                user_level: isAddUserLevel.user_level
            } 
            await ApiEndpoints.JobTaskPayment.insertUserLevel(body);
            this.setState({ isAddUserLevel: false })
            // this.setState({isAddUserLevel});
            this.fetchPartnerLevel();
        }
        catch(e){
            store.dispatch(setError({show: true, message: e.response ? e.response.data.message : e.toString()}))
        }
        store.dispatch(setLoader(false))
    }

     deletePaymentUserLevel = async (userlevel) => {
        
            let { job } = this.props;
            store.dispatch(setLoader(true))
              try{
                let body = {
                    job_id: job.job_id,
                    job_user_level_id: userlevel.job_user_level_id,
                    }
                await ApiEndpoints.JobTaskPayment.inactiveUserLevel(body);
                await this.fetchPartnerLevel();
              }
              catch(e){
                store.dispatch(setError({show: true, message: e.response ? e.response.data.message : e.toString()}))
            }
            store.dispatch(setLoader(false))
        }


    
    render(){
        let { isConfirm, userLevelData, isAddUserLevel} = this.state;
        let { job } = this.props;
       

        return (
            <div className="px-3">
                <Button className="my-3" size={"sm"} color="danger" onClick={() => this.setState({ isAddUserLevel: {} })}>Add Partner</Button>
                
                {!!isAddUserLevel && 
                <form className="my-3" onSubmit={this.addUserLevel}>
                <Row>
                    <Col>
                        <InputFeild required placeholder="Partner PMW ID" value={isAddUserLevel.pmw_id} onChange={(e) => { isAddUserLevel.pmw_id = e.target.value; this.setState({isAddUserLevel}) }} />
                    </Col>
                    <Col>
                        <Input onChange={(e) => { isAddUserLevel.user_level = e.target.value; this.setState({isAddUserLevel}) }} value={isAddUserLevel.user_level} required type="select">
                            <option  value="">All Partners</option>
                            {[1, 2, 3, 4, 5, 6].map(userLevel =>  <option key={userLevel} value={userLevel}>Partner Level {userLevel}</option>)}
                        </Input>
                    </Col>
                    <Col>
                        <Button className="p-0 mr-3" color="link"><Icon id="add_payment_structure_submit" className="" style={{color: "#000", fontSize: "18px"}}>done</Icon> </Button>
                        <Icon id="add_payment_structure_cancel" style={{cursor: "pointer", fontSize: "18px"}} onClick={() => this.setState({isAddUserLevel : false})}>close</Icon>
                    </Col>
                </Row>
                </form>
                }
                
                {
                    userLevelData.map(user => 
                        <Row className="align-items-center border p-2 shadow-sm mb-2">
                            <Col>
                                <span className="d-block" style={{fontSize: 14}}>{user.User && `PMW${user.User.id} | ${user.User.first_name}`}</span>
                                <span className="small text-muted">{moment(user.created_on).format("Do MMM'YY HH:mm")}</span>
                            </Col>
                            <Col>
                                <span className="small font-weight-bold">Partner Level {user.user_level}</span>
                            </Col>
                            <Col xs="auto"><Icon className="clickable" onClick={() => this.setState({isConfirm: () => this.deletePaymentUserLevel(user) })}>delete</Icon></Col>
                        </Row>
                    )
                }
                <ConfirmAction isOpen={!!isConfirm} onClose={() => this.setState({isConfirm : false})} callback={isConfirm} />
            </div>
        );

    }
}

export default JobUserLevel;
